import { SVGProps, Ref, forwardRef } from 'react';

export const UserSingleBanFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10m-2.809 3.465a3.2 3.2 0 0 0 4.343 4.343zM19 15.8c-.556 0-1.08.142-1.535.391l4.343 4.343A3.2 3.2 0 0 0 19 15.8"
                fill="currentColor"
            />
            <path
                d="M10.003 15c1.093 0 2.186.13 3.217.418A6.77 6.77 0 0 0 12.2 19a6.8 6.8 0 0 0 .698 3H1.003c.822-5.202 4.91-7 9-7"
                fill="currentColor"
            />
            <path
                d="M10 2c4.125 0 5.5 2.75 5.5 5.5S14.125 13 10 13s-5.5-2.75-5.5-5.5S5.875 2 10 2"
                fill="currentColor"
            />
        </g>
    </svg>
));
UserSingleBanFilledSize24Glyph.displayName = 'UserSingleBanFilledSize24Glyph';
